import axios from './axios';

const PartnersApi = {
    getAll: () => axios.get('/partners'),
    create: (formData) =>
        axios.post('/partners', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
    remove: (id) => axios.delete(`/partners/${id}`),
};

export default PartnersApi;
